import dayjs from 'dayjs';

const getMonth = (date: Date | string | undefined): number =>
  dayjs(date).month();

export default getMonth;
